import type { ScoreRoute } from '../../../schemas/scoreRoute.js';

export type ExitRouteValue = string | ScoreRoute;

/** A route value is a ScoreRoute when it is a (non-null) object rather than a node-id string. */
export const isScoreRoute = (value: unknown): value is ScoreRoute =>
  typeof value === 'object' && value !== null;

/** Every node id an exit-route value can lead to (unique, non-empty). */
export const collectExitRouteTargets = (value: ExitRouteValue): string[] => {
  if (!isScoreRoute(value)) {
    return value ? [value] : [];
  }
  const branches = Array.isArray(value.branches) ? value.branches : [];
  const targets = [...branches.map(b => b.targetNodeId), value.defaultNodeId];
  return [...new Set(targets.filter((t): t is string => typeof t === 'string' && t.length > 0))];
};
